function TimedScoreContainer({ currentScore }) {
  return <div className="score-remaining">Remaining Score: {currentScore}</div>;
}

export default TimedScoreContainer;
